import axios from 'axios'

export default {
    download(filter, sort) {
        return axios.download('/api/customers/export',
            {
                countryId: filter.countryId,
                chainId: filter.chainId,
                name: filter.text,
                sortBy: sort ? sort.prop : undefined,
                sortOrder: sort ? sort.order : undefined
            });
    },
    getCustomers(page, countryId, chainId, text, city, zip, state, sort, notification) {
        return axios.get('/api/customers/table',
            {
                params: {
                    page: page,
                    countryId: countryId,
                    chainId: chainId,
                    name: text,
                    city: city,
                    zip: zip,
                    state: state,
                    customerNotification: notification,
                    sortBy: sort ? sort.prop : undefined,
                    sortOrder: sort ? sort.order : undefined
                }
            });
    },
    getCustomer(id) {
        return axios.get(`/api/customers/${id}/customerwithequipment`).then(response => {
            var result = Object.assign({}, response.data.customer);
            result.classification = result.classification.toString();
            result.selectedCountryState = [result.address.countryId.toString(), result.address.stateId.toString()];
            result.chainId = [result.chainId.toString(), result.chainRule];
            result.city = result.address.city;
            result.region = result.address.region;
            result.regional = result.address.regional;
            result.zip = result.address.zip;
            result.address = result.address.street;
            result.registeredEquipment.forEach(x => {
                x.model = x.product.name;
                x.warrantyStartString = new Date(x.warrantyStart).toLocaleDateString("en-US");
                x.warrantyEndString = new Date(x.warrantyEnd).toLocaleDateString("en-US");
            });
            result.info = response.data.info.toString();
            result.qrCodeImg = response.data.qrCodeImg ? response.data.qrCodeImg.toString() : null;

            return result;
        });
    },
    getEquipment(id) {
        return axios.get(`/api/customers/${id}/equipment`);
    },
    getNotifications(id) {
        return axios.get(`/api/customers/${id}/notifications`);
    },
    saveCustomer(id, customer) {
        var request = Object.assign({}, customer);
        request.countryId = customer.selectedCountryState[0];
        request.stateId = customer.selectedCountryState[1];

        var chainAndRule = customer.chainId;
        request.chainId = chainAndRule[0];
        request.chainRule = chainAndRule[1];

        delete request.selectedCountryState;
        if (typeof request.email == 'undefined' || request.email == '') {
            request.email = null;
        }
        if (id) {
            return axios.put(`/api/customers/${id}`, request);
        }
        return axios.post('/api/customers', request);
    },
    deleteCustomer(id) {
        return axios.delete(`/api/customers/${id}`);
    },
    saveNotification(id, notification) {
        if (notification.id) {
            return axios.put(`/api/customers/${id}/notifications`, notification);
        }
        return axios.post(`/api/customers/${id}/notifications`, notification);
    },
    deleteNotification(id) {
        return axios.delete(`/api/customers/${id}/notifications`);
    },
    deleteEquipment(id) {
        return axios.delete(`/api/equipment/${id}`);
    },
    saveCountry(country) {
        var request = Object.assign({}, country);
        return axios.post('/api/countries', request);
    },
    getCookingParams(id) {
        return axios.get(`/api/customers/${id}/cooking_params`);
    },
    deleteCookingParam(id) {
        return axios.delete(`/api/customers/${id}/cooking_params`);
    },
    saveCookingParam(id, cookingParam) {
        if (cookingParam.id) {
            return axios.put(`/api/customers/${id}/cooking_params`, cookingParam);
        }
        return axios.post(`/api/customers/${id}/cooking_params`, cookingParam);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/masters/customers/api.js